import React from 'react';
import { Link } from 'react-router-dom';
import { useLandingLanguage } from '../../context/LandingLanguageContext';

const Footer = () => {
  const { t } = useLandingLanguage();
  const skylineUrl = `${process.env.PUBLIC_URL || ''}/assets/images/landing/kasbah.jpeg`;

  return (
    <footer
      data-testid="footer"
      style={{
        position: 'relative',
        overflow: 'hidden',
        marginTop: 0,
        background: '#0F0F0F',
      }}
    >
      {/* Kasbah photo — top fades in so it blends into the same canvas as waitlist */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
          backgroundImage: `url("${skylineUrl}")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center 62%',
          backgroundSize: 'cover',
          opacity: 0.52,
          filter: 'grayscale(8%) brightness(1.08) contrast(1.05) saturate(1.05)',
          WebkitMaskImage:
            'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.06) 6%, rgba(0,0,0,0.22) 16%, rgba(0,0,0,0.45) 32%, rgba(0,0,0,0.68) 48%, rgba(0,0,0,0.88) 62%, #000 78%)',
          maskImage:
            'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.06) 6%, rgba(0,0,0,0.22) 16%, rgba(0,0,0,0.45) 32%, rgba(0,0,0,0.68) 48%, rgba(0,0,0,0.88) 62%, #000 78%)',
          WebkitMaskSize: '100% 100%',
          maskSize: '100% 100%',
        }}
      />
      {/* Scrim — very light at top (same plane as waitlist) then builds toward bottom */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          pointerEvents: 'none',
          background: `linear-gradient(180deg,
            rgba(15,15,15,0.08) 0%,
            rgba(15,15,15,0.14) 12%,
            rgba(14,15,17,0.28) 28%,
            rgba(13,15,19,0.38) 48%,
            rgba(13,15,19,0.26) 68%,
            rgba(13,14,16,0.12) 100%)`,
        }}
      />

      {/* Logo, links, tagline — one centered column aligned to the SIMO PAY wordmark */}
      <div
        style={{
          position: 'relative',
          zIndex: 3,
          width: '100%',
          maxWidth: 520,
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          padding: '48px 24px 180px',
          gap: 14,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            width: '100%',
          }}
        >
          <div style={{
            width: '40px', height: '40px', borderRadius: '12px',
            background: 'linear-gradient(135deg, #D4AF37, #B8962E)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '20px', fontWeight: '800', color: '#0F0F0F', fontFamily: 'Inter, sans-serif',
          }}>S</div>
          <span style={{ fontSize: '24px', fontWeight: '800', color: '#F8F5F0', letterSpacing: '-0.8px', fontFamily: 'Inter, sans-serif' }}>
            SIMO PAY
          </span>
        </div>
        <nav
          aria-label="Footer"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 20,
            width: '100%',
            margin: 0,
          }}
        >
          <Link
            to="/"
            style={{
              color: '#E8D5A0',
              fontSize: '13px',
              fontWeight: '600',
              textDecoration: 'none',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {t('nav.home')}
          </Link>
          <Link
            to="/about"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              color: '#E6D491',
              fontSize: '13px',
              fontWeight: '800',
              textDecoration: 'none',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {t('nav.aboutUs')}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden style={{ flexShrink: 0, display: 'block' }}>
              <path fill="#E6D491" d="M12 3.25L13.62 8.38L18.75 10L13.62 11.62L12 16.75L10.38 11.62L5.25 10L10.38 8.38L12 3.25z" />
            </svg>
          </Link>
        </nav>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
            }}
          >
            <span
              style={{
                color: 'rgba(232,228,218,0.78)',
                fontSize: '12px',
                fontWeight: 600,
                letterSpacing: '0.06em',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {t('footer.builtFor')}
            </span>
            <span role="img" aria-label="Morocco" style={{ fontSize: 16, lineHeight: 1 }}>
              🇲🇦
            </span>
          </div>
        </div>
        <p
          style={{
            color: 'rgba(232,228,218,0.88)',
            fontSize: '13px',
            fontWeight: '600',
            margin: 0,
            width: '100%',
            textAlign: 'center',
            fontFamily: 'Inter, sans-serif',
          }}
        >
          {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
